import React from 'react';
import { useTranslation } from 'react-i18next';

const CsaePage = () => {
  const [t] = useTranslation('global');

  return (
    <div className='min-h-screen bg-white p-6'>
      <section className='text-center mb-12'>
        <h1 className='text-4xl font-bold mb-4'>{t('bikeAlert.title')}</h1>
        <p className='text-lg text-gray-600'>{t('bikeAlert.about')}</p>
      </section>

      <section className='max-w-4xl mx-auto text-justify mb-12'>
        <h2 className='text-2xl font-semibold mb-4'>{t('bikeAlert.how')}</h2>
        <p className='text-gray-700 leading-relaxed'>
          {t('bikeAlert.paragraph2')}
        </p>
      </section>

      <section className='max-w-4xl mx-auto text-justify mb-12'>
        <h2 className='text-2xl font-semibold mb-4'>{t('features.about')}</h2>
        <p className='text-gray-700 leading-relaxed'>
          {t('features.paragraph')}
        </p>
      </section>

      <section className='text-center mt-16'>
        <a
          href='/galeria'
          className='bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition duration-300'
        >
          {t('navigation.button4')}
        </a>
      </section>
    </div>
  );
};

export default CsaePage;
